import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState, User } from '../../utils/types'

const initialState: RootState['currentUser'] = {
  id: '',
  firstName: '',
  lastName: '',
  email: '',
  user_id: '',
  role: ''
}

export const currentUser = createSlice({
  name: 'currentUser',
  initialState: initialState,
  reducers: {
    setCurrentUser: (state, action: PayloadAction<User>) => {
      // state = action.payload;
      return action.payload
    },
    getCurrentUser: state => {
      return state
    }
  }
})

export default currentUser.reducer

export const { setCurrentUser, getCurrentUser } = currentUser.actions
